import styled, { css } from 'styled-components';

// Headings Style
const HeadingStyle = css`
  font-family: 'Bryant Pro Medium';
  font-variant: tabular-nums;
  font-weight: normal;
  letter-spacing: normal;
  margin: 0;
`;

// Text Style
const TextStyle = css`
  font-family: 'Bryant Pro Regular';
  font-variant: tabular-nums;
  font-weight: normal;
  letter-spacing: normal;
  margin: 0;
`;

// Heading 1
const StyledH1 = styled.h1`
  ${HeadingStyle};
  font-size: ${(props) => props.theme.typography.heading1}; /* 36px */
  line-height: 1.2;
  color: ${(props) => props.theme.colors.blueMedium};
`;

// Heading 2
const StyledH2 = styled.h2`
  ${HeadingStyle};
  font-size: ${(props) => props.theme.typography.heading2}; /* 32px */
  line-height: 1.2;
  color: ${(props) => props.theme.colors.blueMedium};
`;

// Heading 3
const StyledH3 = styled.h3`
  ${HeadingStyle};
  font-size: ${(props) => props.theme.typography.heading3}; /* 28px */
  line-height: 1.2;
  color: ${(props) => props.theme.colors.blueMedium};
`;

// Heading 4
const StyledH4 = styled.h4`
  ${HeadingStyle};
  font-size: ${(props) => props.theme.typography.heading4}; /* 24px */
  line-height: 1.2;
  color: ${(props) => props.theme.colors.greyDark};
`;

// Heading 5
const StyledH5 = styled.h5`
  ${HeadingStyle};
  font-size: ${(props) => props.theme.typography.heading5}; /* 20px */
  line-height: 1.2;
  color: ${(props) => props.theme.colors.greyDark};

`;

// Heading 6
const StyledH6 = styled.h6`
  ${HeadingStyle};
  font-size: ${(props) => props.theme.typography.heading6}; /* 16px */
  line-height: 1.2;
  color: ${(props) => props.theme.colors.greyDark};
`;

// Body Text
const StyledText = styled.p`
  ${TextStyle};
  font-size: ${(props) => props.theme.typography.bodyText}; /* 14px */
  line-height: 1.4;
  color: ${(props) => props.color !== undefined ? props.theme.colors[props.color] : props.theme.colors.greyDark};
`;

// Link Text
const StyledTextLink = styled.a`
  ${TextStyle};
  font-size: ${(props) => props.theme.typography.bodyText}; /* 14px */
  line-height: 1.4; 
  text-decoration: none;
  color: ${(props) => props.theme.colors.blueDark};
  transition: .5s all;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

// Small Text (<small>)
const StyledSmall = styled.small`
  font-variant: tabular-nums;
  font-size: ${(props) => props.theme.typography.smallText}; /* 13px */
  line-height: inherit;
`;

// Bold text
const StyledStrong = styled.strong`
  font-variant: tabular-nums;
  font-family: 'Bryant Pro Bold';
  font-weight: normal;
`;

// Medium Text
const StyledMedium = styled.span`
  font-variant: tabular-nums;
  font-family: 'Bryant Pro Medium';
  font-weight: normal;
`;

// Highlighted Text
const StyledHighlight = styled.mark`
  font-variant: tabular-nums;
  background-color: hsl(209.6,100%,85%);
`;

// Italicized Text
const StyledItalic = styled.em`
  font-variant: tabular-nums;
  font-style: italic;
`;

// Underlined Text
const StyledUnderline = styled.u`
  font-variant: tabular-nums;
  text-decoration: underline;
`;

export const Typography = {
  H1: StyledH1,
  H2: StyledH2,
  H3: StyledH3,
  H4: StyledH4,
  H5: StyledH5,
  H6: StyledH6,
  Text: StyledText,
  TextLink: StyledTextLink,
  Small: StyledSmall,
  Strong: StyledStrong,
  Medium: StyledMedium,
  Highlight: StyledHighlight,
  Italic: StyledItalic,
  Underline: StyledUnderline
};
